import React from "react";

import { MenuRounded } from "@mui/icons-material";
import { Box } from "@mui/material";

import useMainState from "../../config/context/mainStateContext";

import MainText from "../../components/MainText";
import PageHeader from "../../components/PageHeader";

export default function PrivacyPolicyPage() {
  const { setShowSideMenuDrawer } = useMainState();

  React.useEffect(() => {}, []);

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"45px"}
    >
      <Box width={"90%"}>
        <PageHeader
          title="Política de Privacidade"
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
        />

        <Box mt={2}>
          <Box mb={2} mt={3}>
            <MainText size="body">A. Introdução</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              1. A privacidade dos visitantes do nosso aplicativo é muito importante para nós, e
              estamos comprometidos em protegê-la. Esta política explica o que faremos com suas
              informações pessoais.
              <br />
              <br />
              2. Consentir com o uso de cookies de acordo com os termos desta política quando você
              acessa nosso aplicativo p
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">B. Créditos</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              Este documento foi criado usando um modelo da SEQ Legal (seqlegal.com) modificado pelo
              Website Planet (www.websiteplanet.com).
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">C. Coleta de informações pessoais</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              Os seguintes tipos de informações pessoais podem ser coletados, armazenados e usados:
              <br />
              <br />
              1. informações sobre o seu dispositivo, incluindo seu endereço IP, localização
              geográfica, tipo e versão do sistema operacional;
              <br />
              <br />
              2. informações sobre suas visitas e uso deste aplicativo, incluindo fonte de
              referência, duração da visita, visualizações de telas e caminhos de navegação no
              aplicativo;
              <br />
              <br />
              3. informações, como seu nome e endereço de e-mail, que você digita quando se registra
              em nosso aplicativo;
              <br />
              <br />
              4. informações que você digita ao criar um perfil em nosso aplicativo - por exemplo,
              seu nome, fotos de perfil, sexo, data de nascimento, status de relacionamento,
              interesses e hobbies, informações educacionais e de emprego;
              <br />
              <br />
              5. informações, como seu nome e endereço de e-mail, que você digita para configurar
              assinaturas de nossos e-mails e/ou newsletters;
              <br />
              <br />
              6. informações que você digita durante o uso dos serviços em nosso aplicativo;
              <br />
              <br />
              7. informações geradas ao usar nosso aplicativo, incluindo quando, com que frequência
              e em que circunstâncias você o utiliza;
              <br />
              <br />
              8. informações relacionadas a tudo o que você compra, serviços que usa ou transações
              que realiza através do nosso aplicativo, incluindo nome, endereço, número de telefone,
              endereço de e-mail e dados do cartão de crédito;
              <br />
              <br />
              9. informações que você publica em nosso aplicativo com a intenção de publicá-las na
              internet, incluindo seu nome de usuário, fotos de perfil e o conteúdo de suas
              publicações;
              <br />
              <br />
              10. informações contidas em quaisquer comunicações que você nos envia por e-mail ou
              através de nosso aplicativo, incluindo o conteúdo e os metadados da comunicação;
              <br />
              <br />
              11. qualquer outra informação pessoal que você nos enviar.
              <br />
              <br />
              Antes de nos divulgar informações pessoais de outra pessoa, você deve obter o
              consentimento dessa pessoa para a divulgação e o processamento dessas informações
              pessoais de acordo com esta política.
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">D. Uso de suas informações pessoais</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              As informações pessoais que nos são enviadas por meio de nosso aplicativo serão usadas
              para os fins especificados nesta política ou nas páginas relevantes do aplicativo.
              Podemos usar suas informações pessoais para o seguinte:
              <br />
              <br />
              1. administrar nosso aplicativo e nossos negócios; 2. personalizar nosso aplicativo
              para você;
              <br />
              <br />
              3. possibilitar o uso dos serviços disponíveis em nosso aplicativo;
              <br />
              <br />
              4. enviar produtos adquiridos através do nosso aplicativo;
              <br />
              <br />
              5. prestar serviços adquiridos através do nosso aplicativo;
              <br />
              <br />
              6. enviar extratos, faturas e lembretes de pagamento, bem como coletar seus
              pagamentos;
              <br />
              <br />
              7. enviar comunicações comerciais que não sejam de marketing;
              <br />
              <br />
              8. enviar notificações por e-mail solicitadas especificamente por você;
              <br />
              <br />
              9. enviar nossa newsletter por e-mail, caso você a tenha solicitado (você pode nos
              informar a qualquer momento se não quiser mais receber a newsletter);
              <br />
              <br />
              10. enviar comunicações de marketing relacionadas aos nossos negócios ou aos negócios
              de terceiros cuidadosamente selecionados que acreditamos ser do seu interesse, por
              correio ou, onde você especificamente concordou com isso, por e-mail ou tecnologia
              semelhante (você pode nos informar a qualquer momento se não mais quiser mais receber
              comunicações de marketing);
              <br />
              <br />
              11. fornecer a terceiros informações estatísticas sobre nossos usuários (mas esses
              terceiros não poderão identificar nenhum usuário individual a partir dessas
              informações);
              <br />
              <br />
              12. lidar com perguntas e reclamações feitas por você ou sobre você em relação ao
              nosso aplicativo;
              <br />
              <br />
              13. manter nosso aplicativo seguro e evitar fraudes;
              <br />
              <br />
              14. verificar a conformidade com os termos e condições que regem o uso do nosso
              aplicativo (incluindo o monitoramento de mensagens privadas enviadas por meio do
              serviço de mensagens privadas do nosso aplicativo);
              <br />
              <br />
              15. outros usos.
              <br />
              <br />
              Se você enviar informações pessoais para publicação em nosso aplicativo, publicaremos
              e usaremos essas informações de acordo com a licença que você nos concedeu.
              <br />
              <br />
              Suas configurações de privacidade podem ser usadas para limitar a publicação de suas
              informações em nosso aplicativo e ajustadas através do uso de controles de privacidade
              no aplicativo.
              <br />
              <br />
              Sem seu consentimento expresso, não forneceremos suas informações pessoais a terceiros
              para fins de marketing direto por parte deles ou de terceiros.
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body"> E. Divulgação de informações pessoais</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              Podemos divulgar suas informações pessoais a qualquer um de nossos funcionários,
              executivos, seguradoras, consultores profissionais, agentes, fornecedores ou
              subcontratados conforme razoavelmente necessário para os fins estabelecidos nesta
              política.
              <br />
              <br />
              Podemos divulgar suas informações pessoais a qualquer membro de nosso grupo de
              empresas (isso significa nossas subsidiárias, nossa holding e todas as suas
              subsidiárias) conforme razoavelmente necessário para os fins estabelecidos nesta
              política. Podemos divulgar suas informações pessoais:
              <br />
              <br />
              1. na medida em que somos obrigados a fazê-lo por lei;
              <br />
              <br />
              2. em relação a qualquer processo judicial em andamento ou potencial;
              <br />
              <br />
              3. para estabelecer, exercer ou defender nossos direitos legais (incluindo fornecer
              informações a terceiros para fins de prevenção de fraudes e redução do risco de
              crédito);
              <br />
              <br />
              4. ao comprador (ou comprador em potencial) de qualquer negócio ou ativo que estejamos
              vendendo (ou contemplando vender);
              <br />
              <br />
              5. a qualquer pessoa que acreditemos razoavelmente que possa solicitar a um tribunal
              ou outra autoridade competente a divulgação dessas informações pessoais, quando, em
              nossa opinião razoável, for provável que tal tribunal ou autoridade ordene a
              divulgação dessas informações pessoais.
              <br />
              <br />
              Exceto conforme estabelecido nesta política, não forneceremos suas informações
              pessoais a terceiros.
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">F. Transferências internacionais de dados</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              1. As informações que coletamos podem ser armazenadas, processadas e transferidas
              entre qualquer um dos países em que operamos, a fim de nos permitir usar as
              informações de acordo com esta política.
              <br />
              <br />
              2. As informações que coletamos podem ser transferidas para os seguintes países que
              não possuem leis de proteção de dados equivalentes às vigentes no Espaço Econômico
              Europeu: Estados Unidos da América, Rússia, Japão, China e Índia.
              <br />
              <br />
              3. As informações pessoais que você publica em nosso aplicativo ou envia para
              publicação em nosso aplicativo podem estar disponíveis, através da internet, em todo o
              mundo. Não podemos impedir o uso ou uso indevido de tais informações por terceiros.
              <br />
              <br />
              4. Você concorda expressamente com as transferências de informações pessoais descritas
              nesta seção F.
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">G. Retenção de informações pessoais</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              1. Esta seção G define nossas políticas e procedimentos de retenção de dados,
              projetados para ajudar a garantir o cumprimento de nossas obrigações legais em relação
              à retenção e exclusão de informações pessoais.
              <br />
              <br />
              2. As informações pessoais que processamos para qualquer propósito ou propósitos não
              devem ser mantidas por mais tempo do que o necessário para esse propósito ou
              propósitos.
              <br />
              <br />
              3. Sem prejuízo do artigo G-2, geralmente excluiremos dados pessoais pertencentes às
              categorias definidas abaixo na data definidas abaixo:
              <br />
              <br />
              1. Dados pessoais serão excluído em até 5 anos; e
              <br />
              <br />
              2. Dados de uso do aplicativo serão mantidos indefinidamente.
              <br />
              <br />
              4. Não obstante as outras disposições desta seção G, reteremos documentos (incluindo
              documentos eletrônicos) que contenham dados pessoais:
              <br />
              <br />
              1. na medida em que somos obrigados a fazê-lo por lei;
              <br />
              <br />
              2. se acreditarmos que os documentos podem ser relevantes para qualquer processo
              judicial em andamento ou potencial; e
              <br />
              <br />
              3. para estabelecer, exercer ou defender nossos direitos legais (incluindo fornecer
              informações a terceiros para fins de prevenção de fraudes e redução do risco de
              crédito)
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">H. Segurança de suas informações pessoais</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              1. Tomaremos as devidas precauções técnicas e organizacionais para evitar a perda,
              <br />
              <br />
              mau uso ou alteração de suas informações pessoais. 2. Armazenaremos todas as suas
              informações pessoais fornecidas em nossos servidores seguros (protegidos por senha e
              firewall).
              <br />
              <br />
              3. Todas as transações financeiras eletrônicas realizadas através do nosso site serão
              protegidas por tecnologia de criptografia.
              <br />
              <br />
              4. Você reconhece que a transmissão de informações pela internet é inerentemente
              insegura e que não podemos garantir a segurança dos dados enviados pela internet.
              <br />
              <br />
              5. Você é responsável por manter em sigilo a senha usada para acessar nosso site; não
              solicitaremos sua senha (exceto quando você fizer login em nosso site).
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">I. Alterações</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              Podemos atualizar esta política periodicamente, através da publicação de uma nova
              versão em nosso site. Você deve verificar esta página ocasionalmente para garantir que
              compreende quaisquer alterações nesta política. Podemos notificá-lo sobre alterações
              nesta política por e-mail ou através do sistema de mensagens privadas em nosso site.
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">J. Seus direitos</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              Você pode nos instruir a fornecer qualquer informação pessoal que detenhamos sobre
              você; o fornecimento dessas informações estará sujeito ao seguinte:
              <br />
              <br />
              1. pagamento de uma taxa a ser definida; e
              <br />
              <br />
              2. fornecimento de evidência apropriada de sua identidade (Aceitaremos uma cópia
              autenticada do seu passaporte acrescida de uma cópia original de uma fatura de serviço
              mostrando seu endereço atual).
              <br />
              <br />
              Podemos reter as informações pessoais solicitadas na extensão permitida por lei.
              <br />
              <br />
              Você pode nos instruir a qualquer momento para não processar suas informações pessoais
              para fins de marketing.
              <br />
              <br />
              Na prática, você geralmente concordará expressamente com antecedência com o uso de
              suas informações pessoais para fins de marketing, ou ofereceremos a oportunidade de
              não permitir o uso de suas informações pessoais para fins de marketing.
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">K. Sites de terceiros</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              Nosso site inclui links para e detalhes de sites de terceiros. Não temos controle
              sobre e não somos responsáveis pelas políticas e práticas de privacidade de terceiros.
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">L. Atualização de informações</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              Informe-nos se as informações pessoais que mantemos sobre você precisam ser corrigidas
              ou atualizadas.
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body">M. Cookies</MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular">
              Nosso aplicativo e site usa cookies. Um cookie é um arquivo que contém um
              identificador (uma sequência de letras e números) que é enviado por um servidor da web
              para um navegador e armazenado pelo navegador. O identificador é então enviado de
              volta ao servidor toda vez que o navegador solicita uma página do servidor. Os cookies
              podem ser cookies “persistentes” ou cookies “de sessão”: um cookie persistente será
              armazenado por um navegador e permanecerá válido até a data de vencimento definida, a
              menos que seja excluído pelo usuário antes da data de vencimento; um cookie de sessão,
              por outro lado, expirará no final da sessão do usuário, quando o navegador for
              fechado. Os cookies normalmente não contêm nenhuma informação que identifique
              pessoalmente um usuário, mas as informações pessoais que armazenamos sobre você podem
              estar vinculadas às informações armazenadas e obtidas a partir de cookies. Utilizamos
              cookies persistentes e de sessão em nosso site.
              <br />
              <br />
              1. Os nomes dos cookies que usamos em nosso site e os propósitos para os quais são
              usados estão descritos abaixo:
              <br />
              <br />
              1. usamos o Google Analytics e o Adwords em nosso site e aplicativo para reconhecer um
              dispositivo quando um usuário acessa o site, rastrear usuários enquanto eles navegam
              no site, permitir o uso de um carrinho de compras no site, melhorar a usabilidade do
              site, analisar o uso do site e aplicativo, administrar o site e o plicativo, evitar
              fraudes e melhorar a segurança do site e aplicativo, personalizar o site e aplicativo
              para cada usuário, segmentar anúncios que podem ser de interesse particular para
              usuários específicos;
              <br />
              <br />
              2. A maioria dos navegadores permite que você se recuse a aceitar cookies – por
              exemplo:
              <br />
              <br />
              1. no Internet Explorer (versão 10), você pode bloquear cookies usando as
              configurações disponíveis de cancelamento de manipulação de cookies clicando em
              “Ferramentas”, “Opções da Internet” “Privacidade” e “Avançado”;
              <br />
              <br />
              2. no Firefox (versão 24), você pode bloquear todos os cookies clicando em
              “Ferramentas”, “Opções”, “Privacidade”, selecionando “Usar configurações
              personalizadas para o histórico” no menu suspenso e desmarcando “Aceitar cookies de
              sites” ; e
              <br />
              <br />
              3. no Chrome (versão 29), você pode bloquear todos os cookies acessando o menu
              “Personalizar e controlar” e clicando em “Configurações”, “Avançado” e “Configurações
              do site” e, em seguida, selecionando “Bloquear cookies de terceiros” na seção “Cookies
              e dados do site”.
              <br />
              <br />
              O bloqueio de todos os cookies causará um impacto negativo na usabilidade de muitos
              sites. Se você bloquear os cookies, não poderá usar todos os recursos em nosso site.
              3. Você pode excluir os cookies que já estão armazenados no seu computador – por
              exemplo:
              <br />
              <br />
              1. no Internet Explorer (versão 10), você deve excluir os arquivos de cookies
              manualmente (confira instruções para fazê-lo em http://support.microsoft.com/kb/278835
              );
              <br />
              <br />
              2. no Firefox (versão 24), você pode excluir os cookies clicando em “Ferramentas”,
              “Opções”, “Privacidade”, selecionando “Usar configurações personalizadas para o
              histórico”, clicando em “Mostrar cookies” e, então, em “Remover todos os cookies”; e
              <br />
              <br />
              3. no Chrome (versão 29), você pode excluir todos os cookies acessando o menu
              “Personalizar e controlar” e clicando em “Configurações”, “Avançado”, “Limpar dados de
              navegação” e, em seguida, selecionando “Excluir cookies e outros dados de sites e
              plugins” antes de clicar em “Limpar dados de navegação”.
              <br />
              <br />
              4. A exclusão de cookies causará um impacto negativo na usabilidade de muitos sites.
            </MainText>
          </Box>

          <Box mb={2} mt={3}>
            <MainText size="body"></MainText>
          </Box>

          <Box mb={1}>
            <MainText size="body" color="regular"></MainText>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
